import React, { memo } from 'react';

import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import cn from 'classnames';
import { Spinner } from '@picsio/ui';

import { selectEffectiveChannelState, selectIsVariantChannelPanelHydrating } from '../../store/selectors/productSelectors';
import ProductStateTabs from './ProductStateTabs';
import ConnectChannelSection from './ConnectChannelSection';
import styles from './styles.module.scss';

const ProductInfo = ({ productId, variantId }) => {
  const isProductsLoaded = useSelector((state) => state.products.isLoaded);
  const product = useSelector((state) => state.products.items?.find(({ _id }) => productId === _id) || {});
  const { isMasterView } = useSelector((state) => selectEffectiveChannelState(state, productId, variantId));
  const isVariantChannelPanelHydrating = useSelector(
    (state) => selectIsVariantChannelPanelHydrating(state, productId, variantId),
  );

  /** Show loading spinner if product is not fully loaded (availableOptions not fetched yet) */
  // if (!isProductsLoaded || product.isLoading || !product.availableOptions) {
  if (!isProductsLoaded || product.isLoading || isVariantChannelPanelHydrating) {
    return (
      <div className="InfoPanel">
        <Spinner text="Loading data..." />
      </div>
    );
  }

  return (
    <div className={`InfoPanel${product.isBusy ? ` ${styles.disabled}` : ' '} `}>
      <div data-qa="details-header" className={cn('detailsPanel__header  detailsPanel__btns', styles.header)}>
        <If condition={isMasterView}>
          <ConnectChannelSection productId={productId} />
        </If>
      </div>
      <ProductStateTabs productId={productId} />
    </div>
  );
};

ProductInfo.propTypes = {
  productId: string.isRequired,
  variantId: string,
};

ProductInfo.defaultProps = {
  variantId: null,
};

export default memo(ProductInfo);
